let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("at6NW")).then(() => parcelRequire('4H15d'));